import React from 'react';

function LoadingSpinner() {
  return (
    <div className="c-loader"></div>
  );
}

export default LoadingSpinner;
